import { cx } from '@flowus/common/cx';
import { CollectionViewType } from '@next-space/fe-api-idl';
import type { FC } from 'react';
import { useBitable } from 'src/bitable/context';
import { Icon } from 'src/common/components/icon';
import { useBitableLoadMoreContext } from './hooks';

export const BitableLoadMore: FC = () => {
  const { viewType } = useBitable();
  const { loadMore, showMore } = useBitableLoadMoreContext();

  if (!showMore) return null;

  return (
    <div
      onClick={loadMore}
      className={cx(
        'w-full h-9 flex items-center text-t2 text-grey4 pl-1 cursor-pointer animate-hover-black3',
        (viewType === CollectionViewType.TABLE || viewType === CollectionViewType.LIST) &&
          'border-b'
      )}
    >
      <Icon name="IcMore" size="middle" className="mr-1" />
      展开更多
    </div>
  );
};
